import React from "react";

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import VanWestendorpQuestionsForm from "./VanWestendorpQuestionsForm";

const VanWestendorpQuestions = ({ respondentId, vanWestendorp, onSubmit, formActions }) => {
    // const formikRef = useRef(null);
    // const dispatch = useDispatch();

    const renderProductDescription = (description) => {
        return (
            <React.Fragment>
                <Typography variant="caption" sx={{ fontWeight: 'bold', ml: 2 }}>Product Description</Typography>

                <Card sx={{ maxWidth: 500, minHeight: 100, ml: 2 }}>
                    <CardContent>
                        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                            {description}
                        </Typography>
                    </CardContent>
                </Card>
            </React.Fragment>
        )
    }

    return (
        <Box>
            <Stack direction="column">
                {renderProductDescription(vanWestendorp.product_description)}
                <VanWestendorpQuestionsForm
                    respondentId={respondentId}
                    vanWestendorp={vanWestendorp}
                    formActions={formActions}
                    onSubmit={onSubmit}
                />
            </Stack>
        </Box>
    )
}

export default VanWestendorpQuestions